import React from 'react';
import { Quote } from 'acscp/store';
import { QuoteElement } from 'acscp/components/quotes/quote';
import style from './quotesList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row } from 'acscp/components/common/row';

interface QuotesListProps {
    quotes: Quote[];
    jetCardHolder: boolean;
    jetCardType: string | null;
    isInAcmiWorkflow: boolean;
}

const QuotesListComponent:
    React.FC<QuotesListProps> = ({quotes, jetCardHolder, jetCardType, isInAcmiWorkflow}) => (

    <section className={style.QuotesList}>
        <div className={style.ListHeaderBar}>
            <div className={style.ListTitle}>
                <FormattedMessage id={'components.quotes.quotesList.quotes'} defaultMessage={'QUOTES'} />
            </div>
            <div className={style.Count}>
                <FormattedMessage
                    id={'components.quotes.quotesList.items'}
                    defaultMessage={'{quoteCount} Items'}
                    values={{ quoteCount: quotes.length }}
                />
            </div>
        </div>
        {quotes.map(
            quote => (
                <div key={quote.id}>
                    <QuoteElement
                        quote={quote}
                        collapsible={true}
                        jetCardHolder={jetCardHolder}
                        jetCardType={jetCardType}
                    />
                    {isInAcmiWorkflow &&
                        <Row className={style.AcmiRemarksNotes}>
                            <FormattedMessage
                                id={'components.flightRequest.acmiRemarksNotes'}
                                defaultMessage={'If you require any further information on the above aircraft and offer,' +
                                    ' please do not hesitate to contact me on the details presented. I look forward ' +
                                    'to your feedback at the earliest opportunity.'}
                            />
                        </Row>
                    }
                </div>)
        )}
    </section>
);

const QuotesList = injectIntl(QuotesListComponent);
export { QuotesList };
